import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { Categoria } from 'my-lib-sanfelici';
import { Cataloghi } from 'my-lib-sanfelici';
import { CategorieService } from 'my-lib-sanfelici';
import { CataloghiService } from 'my-lib-sanfelici';



@Component({
  selector: 'app-categoria-form',
  templateUrl: './categoria-form.component.html',
  styleUrls: ['./categoria-form.component.css']
})
export class CategoriaFormComponent implements OnInit {
  categorie: Observable<Categoria[]>;
  cataloghi: Observable<Cataloghi[]>;
  id: string;
@Input() categoria: any;
  constructor(
    private categorieService: CategorieService,
    private cataloghiservice: CataloghiService
  ) { }

  ngOnInit() {
    this.categorie = this.categorieService.list();
    this.cataloghi = this.cataloghiservice.list();

  }

}
